import React from 'react';
import PropTypes from 'prop-types';
import Carousel from '@domain-group/fe-allhomes-nuka-carousel';
import { ChevronLeftIcon, ChevronRightIcon } from '@domain-group/fe-co-icon';
import { AgentType } from '@domain-group/fe-allhomes-library';
import agentType from './props/agent-type';
import AgentCard from './carousel-agent-card';
import PrivateListerCard from './carousel-private-lister-card';
import * as styles from './agent-carousel.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var buildControl = direction =>
// eslint-disable-next-line react/prop-types
_ref => {
  var previousSlide = _ref.previousSlide,
    nextSlide = _ref.nextSlide;
  var isLeft = direction === 'left';
  var Component = isLeft ? ChevronLeftIcon : ChevronRightIcon;
  return ___EmotionJSX(Component, {
    css: styles.arrows,
    onClick: isLeft ? previousSlide : nextSlide
  });
};
class AgentCarousel extends React.PureComponent {
  render() {
    var showArrows = this.props.agents.length > 1;
    return ___EmotionJSX(Carousel, {
      beforeSlide: this.props.beforeChange,
      decorators: showArrows ? [{
        component: buildControl('left'),
        position: 'CenterLeft',
        style: {
          top: '25%'
        }
      }, {
        component: buildControl('right'),
        position: 'CenterRight',
        style: {
          top: '25%'
        }
      }] : [],
      initialSlideHeight: 132,
      initialSlideWidth: 286,
      css: styles.carousel,
      autoplay: this.props.isAutoplay && showArrows,
      autoplayInterval: 5000,
      slidesToShow: 1,
      wrapAround: true
    }, this.props.agents.map(agent => {
      var Component = agent.agency.type === AgentType.PrivateLister.name ? PrivateListerCard : AgentCard;
      return ___EmotionJSX(Component, {
        key: "".concat(agent.name, "-").concat(agent.agency.name),
        agent: agent
      });
    }));
  }
}
AgentCarousel.propTypes = {
  agents: PropTypes.arrayOf(PropTypes.shape(agentType)),
  beforeChange: PropTypes.func,
  isAutoplay: PropTypes.bool
};
AgentCarousel.defaultProps = {
  agents: [],
  beforeChange: () => {},
  isAutoplay: true
};
export default AgentCarousel;